import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';
import { BrandRatingQueueItem } from 'src/typings';
import { BrandService } from '../brand.service';

// Рейтинг бренда решает, в какой ярус подбора попадёт предложение, но заполнен он вручную
// у малой части брендов. Этот экран показывает непроставленные бренды в порядке того, как
// часто мы их продаём и как часто они попадают в подбор, — чтобы закрыть пробел за один присест.
@Component({
  selector: 'app-brand-rating-queue',
  templateUrl: './rating-queue.component.html',
  styleUrls: ['./rating-queue.component.scss']
})
export class RatingQueueComponent implements OnInit, OnDestroy {
  readonly ratingOptions = [1, 2, 3, 4, 5];

  readonly columnsToDisplay = ['description', 'sales', 'hits', 'products', 'rating'];

  items: BrandRatingQueueItem[] = [];

  loading = false;

  savingBrandIds = new Set<number>();

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly brandService: BrandService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.reload();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reload() {
    this.loading = true;
    this.brandService
      .getRatingQueue(200)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (items) => {
          this.items = items || [];
        },
        () => {
          this.notificationService.showError('Не удалось загрузить бренды без рейтинга');
        }
      );
  }

  isSaving(item: BrandRatingQueueItem) {
    return this.savingBrandIds.has(item.id);
  }

  setRating(item: BrandRatingQueueItem, rating: number) {
    if (this.savingBrandIds.has(item.id)) {
      return;
    }

    this.savingBrandIds.add(item.id);
    this.brandService
      .update({ id: item.id, rating })
      .pipe(
        finalize(() => this.savingBrandIds.delete(item.id)),
        takeUntil(this.destroy$)
      )
      .subscribe(
        () => {
          // Проставленный бренд уходит из очереди — список всегда показывает оставшуюся работу.
          this.items = this.items.filter((row) => row.id !== item.id);
          this.notificationService.notice(`${item.description}: рейтинг ${rating}`);
        },
        () => {
          this.notificationService.showError(
            `Не удалось сохранить рейтинг для ${item.description}`
          );
        }
      );
  }
}
